import "./styles.scss";
import React, { FC } from "react";

interface IProps {
  title: string,
  chips: string[],
}

const CompanyExtraDetailItem: FC<IProps> = (props: IProps) => {
  const { title, chips } = props;

  const chipsGroup: JSX.Element[] = chips.map(
    (chip, index) => (
      <span key={index} className="ps-company-extra-detail-item__chip">{chip}</span>
    ),
  );

  return (
    <div className="ps-company-extra-detail-item">
      <span className="ps-company-extra-detail-item__title">{title}</span>
      {chipsGroup}
    </div>
  );
};

export default CompanyExtraDetailItem;
